import { CountryFormConfiguration } from "../constants";
import { Malaysia } from "./MY";

export const MalaysiaZH: CountryFormConfiguration = Malaysia("zh-MY");
